module.exports = __webpack_public_path__ + "PnxCspIcons.e8a05607e6b6078c0057.woff";


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/assets/fonts/PnxCspIcons/fonts/PnxCspIcons.woff?gea4vk
// module id = ../../../../../client/assets/fonts/PnxCspIcons/fonts/PnxCspIcons.woff?gea4vk
// module chunks = styles